const translations = {
  page_title: 'Analytics',

  source_placeholder: 'Source',
  period_placeholder: 'Period',
  since_placeholder: 'Since',
  until_placeholder: 'Until',
  sort_placeholder: 'Sort by',
  filter_placeholder: 'Filter by',
  show_placeholder: 'Show by',

  print_report: 'Print report',

  total_traffic: 'Traffic',
  total_shares: 'Shares - AutoComparte',
  traffic_by_period: 'Traffic by period',
  traffic_by_device: 'Traffic by device',

  pages: 'Pages',
  sources: 'Sources',

  all: 'All domains',
  this_month: 'This month',
  this_week: 'This week',
  custom: 'Custom',
  views: 'Views',
  site: 'Site',
  user: 'User',
  domain: 'Domain',
  count: 'Count',
  page: 'Page',
  source: 'Source',

  impressions: 'Impressions',
  featured: 'Featured',
  inventory: 'Inventory',

  convertions: 'Convertions',
  interaction: 'Interaction',
  total: 'Total',
  convertions_by_period: 'Convertions by period',
  convertions_by_device: 'Convertions by device',
  convertions_by_form_type: 'Convertions by form type',
  group_by_event: 'By event',
  group_by_form_type: 'By form type',
  no_form_type_data: 'No form type data for this period',
  form_type_contact: 'Contact',
  form_type_favorites: 'Favorites',
  form_type_reach: 'Reach',
  form_type_financing: 'Financing',
  form_type_service: 'Service',
  form_type_schedule: 'Schedule',
  form_type_parts: 'Parts',
  form_type_actual_price: 'Actual price',
  form_type_check_availability: 'Check availability',
  form_type_testdrive: 'Test drive',
  form_type_request_test_drive: 'Test drive',
  form_type_tradein: 'Trade-in',
  form_type_trade_in: 'Trade-in',
  form_type_video_tour: 'Video tour',
  form_type_price_cut: 'Price cut',
  leads_by_hour: 'Leads by hour of day',
  leads_by_hour_subtitle: 'Selected range rolled into 24 hours (Puerto Rico time)',
  leads_by_hour_info: 'About leads by hour',
  leads_by_hour_tooltip:
    'Form leads (no bots), in America/Puerto Rico (UTC-4, no DST). Each bar is the hour of day across the whole date range, not a timeline. Empty hours show 0. Business hours are 9 AM–6 PM.',
  during_hours: 'Business hours',
  after_hours: 'After hours',
  leads_by_hour_bar: 'Hourly leads chart',
  leads_by_hour_donut: 'After-hours leads',
  am: 'AM',
  pm: 'PM',

  vehicles_performance: 'Vehicles performance',
  vehicle: 'Vehicle',
  vin: 'VIN',

  more_views: 'More views',
  less_views: 'Less views',
  more_impressions: 'More impresions',
  more_total: 'More total',
  total_views: 'Total views',
  total_impressions: 'Total impressions',
  total_featured: 'Total featured',
  total_convertions: 'Total convertions',

  distribution_by_device: 'Distribution by device',
  view_more: 'View more',

  bot_visits: 'Bot visits',
  bot_visits_subtitle: 'AI bot visits (excludes Google AI overviews)',
  bot_visits_info: 'About bot visits',
  bot_visits_tooltip:
    'AI crawler pageviews (GPTBot, ChatGPT-User, Bytespider, Amazonbot, facebookexternalhit, and others). These are raw pageviews, not sessions. Bot names are detected from the User-Agent. Human traffic is counted in regular pageviews.',
  more_bots: '+{{count}} more',
  area_chart: 'Area chart',
  bar_chart: 'Bar chart',

  select_domain_to_view_report: 'Select a domain to view analytics',
  select_domain_description: 'Choose one or more domains, or All domains, to load site analytics.',
  select_account_to_view_report: 'Select accounts to view the report',
  select_account_description: 'Choose a country and one or more accounts to load site analytics.',
  select_accounts: 'Select accounts',
};

export default translations;
